import React from "react";
import styled from "styled-components";
import {CircularProgress} from "@mui/material";

export const Preloader = styled.div`
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;

	@keyframes lds-ellipsis1 {
		0% {
			transform: scale(0);
		}
		100% {
			transform: scale(1);
		}
	}

	@keyframes lds-ellipsis3 {
		0% {
			transform: scale(1);
		}
		100% {
			transform: scale(0);
		}
	}

	@keyframes lds-ellipsis2 {
		0% {
			transform: translate(0, 0);
		}
		100% {
			transform: translate(24px, 0);
		}
	}

	div {
		position: absolute;
		top: 33px;
		width: 13px;
		height: 13px;
		border-radius: 50%;
		background: #ffffff;
		animation-timing-function: cubic-bezier(0, 1, 1, 0);

		&:nth-child(1) {
			left: 8px;
			animation: lds-ellipsis1 0.6s infinite;
		}

		&:nth-child(2) {
			left: 8px;
			animation: lds-ellipsis2 0.6s infinite;
		}

		&:nth-child(3) {
			left: 32px;
			animation: lds-ellipsis2 0.6s infinite;
		}

		&:nth-child(4) {
			left: 56px;
			animation: lds-ellipsis3 0.6s infinite;
		}
	}
`;

const PagePreloaderWrapper = styled.div`
	background: ${({theme}) => theme.primary};
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const PagePreloader: React.FC = () => (
	<PagePreloaderWrapper>
		<Preloader>
			<div />
			<div />
			<div />
			<div />
		</Preloader>
	</PagePreloaderWrapper>
);

interface IProps {
	color?: string;
	size?: number;
}

export const CircularPreloaded: React.FC<IProps> = ({color = "#000151", size}) => {
	return (
		<CircularProgress
			size={size}
			sx={{
				color: () => color,
			}}
		/>
	);
};
